module.exports = __webpack_public_path__ + "static/media/RIO-GRANDE_LowerLevel-Layout.6213dad6.jpg";